export function getInitials(username: string) {
    if (!username) return ''
    const names = username.split(' ')
    const firstName = names.at(0)
    if (!firstName) return ''
    const lastName = names.at(-1)
    if (!lastName || firstName === lastName) return firstName.substring(0, 2).toUpperCase()
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
}
